import React from "react";
import {render} from "react-dom";
import {Provider} from "react-redux";
import {BrowserRouter} from "react-router-dom";
import store from "./store";
import App from "./component/App";
import "./static/css/reset.min.css";
render(
    <Provider store={store}>
    <BrowserRouter>
        <App local="zh"/>
    </BrowserRouter>
</Provider>, window.root);











// WEBPACK FOOTER //
// ./src/index.js